import { formatDate, formatTime } from '../Utils/dateHelper.js';

const addZero = (value) => (value < 10 ? `0${value}` : value);
const createTime = (date, showMills) => {
    let dateString = formatTime(date, true);
    if (showMills) {
        const mills = addZero(date.getMilliseconds());
        dateString += `,${mills}`;
    }
    return dateString;
};
function formattedDate(value, type) {
    const date = new Date(value);
    let result = '';
    switch (type) {
        case 'date':
            result = formatDate(date);
            break;
        case 'date-detailed':
            result = `${formatDate(date)} ${createTime(date, true)}`;
            break;
        case 'date-time':
            result = `${formatDate(date)} ${createTime(date, false)}`;
            break;
    }
    return result;
}

export { formattedDate as default };
